module.exports = __webpack_public_path__ + "static/media/address.42caa5e2.svg";